module.exports = __webpack_public_path__ + "static/img/pie-chart-4.e2d7ca52.svg";